exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.card-flat {\n  transition: transform 1s;\n  transform-style: preserve-3d;\n}\n.card-flat.card--flipped {\n    transform: rotateY(180deg);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ce559964","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/photo-card.vue
// module id = 29
// module chunks = 0